import React from 'react'
import { Checkbox } from '../UI'

const SendModal = ({ sms, email, ...props }) => {
  return (
    <div className="modal-send">
      <Checkbox id={'sms-' + props.index} value={sms} checked={sms} handleChange={props.handleSmsClick}>
        SMS
      </Checkbox>
      <Checkbox id={'email-' + props.index} value={email} checked={email} handleChange={props.handleEmailClick}>
        Email
      </Checkbox>
      <button className="btn btn-danger" onClick={props.handleSubmit}>
        Apply
      </button>
    </div>
  )
}

export default SendModal



// WEBPACK FOOTER //
// src/components/MyTrips/SendModal.js